/* GENERATED FILE - DO NOT EDIT BY HAND
 * Source of truth: frontend/src/theme/tokens.css
 * Regenerate:      python3 scripts/sync_design_tokens.py
 *
 * Resolved literal colours for the consumers that cannot read CSS custom
 * properties: pdfmake documents (invoices, QA reports) and SVG presentation
 * attributes (Recharts series, lucide icon props). Everything else in the
 * app must use var(--token) instead of importing from here.
 */

export const COLORS = {
  brand50: '#eff6ff',
  brand100: '#dbeafe',
  brand200: '#bfdbfe',
  brand300: '#93c5fd',
  brand400: '#60a5fa',
  brand500: '#3b82f6',
  brand600: '#2563eb',
  brand700: '#1d4ed8',
  brand800: '#1e40af',
  brand900: '#1e3a8a',
  brand950: '#172554',
  ink0: '#ffffff',
  ink50: '#f7f7f7',
  ink100: '#efefef',
  ink200: '#e2e2e2',
  ink300: '#cfcfcf',
  ink400: '#a3a3a3',
  ink500: '#7a7a7a',
  ink600: '#5c5c5c',
  ink700: '#404040',
  ink800: '#2b2b2b',
  ink900: '#1a1a1a',
  ink950: '#0d0d0d',
  accent: '#2563eb',
  accentHover: '#1d4ed8',
  accentActive: '#1e40af',
  accentLight: '#eff6ff',
  accentBorder: '#bfdbfe',
  text: '#1a1a1a',
  textStrong: '#0d0d0d',
  textMuted: '#5c5c5c',
  textFaint: '#7a7a7a',
  textDisabled: '#a3a3a3',
  textOnAccent: '#ffffff',
  textOnDark: 'rgba(255, 255, 255, 0.92)',
  textOnDarkMuted: 'rgba(255, 255, 255, 0.62)',
  bg: '#f7f7f7',
  bgCard: '#ffffff',
  bgSubtle: '#efefef',
  bgHover: '#efefef',
  bgActive: '#e2e2e2',
  bgInverse: '#1a1a1a',
  scrim: 'rgba(13, 13, 13, 0.55)',
  border: '#e2e2e2',
  borderSubtle: '#efefef',
  borderStrong: '#cfcfcf',
  borderInverse: 'rgba(255, 255, 255, 0.16)',
  success: '#16a34a',
  successHover: '#15803d',
  successBg: '#f0fdf4',
  successBorder: '#bbf7d0',
  successText: '#15803d',
  warning: '#f59e0b',
  warningHover: '#d97706',
  warningBg: '#fffbeb',
  warningBorder: '#fde68a',
  warningText: '#b45309',
  danger: '#dc2626',
  dangerHover: '#b91c1c',
  dangerBg: '#fef2f2',
  dangerBorder: '#fecaca',
  dangerText: '#991b1b',
  info: '#2563eb',
  infoBg: '#eff6ff',
  infoBorder: '#bfdbfe',
  infoText: '#1e40af',
  aiAccent: '#7c3aed',
  aiAccentHover: '#6d28d9',
  aiAccentTint: 'rgba(124, 58, 237, 0.08)',
  aiAccentBorder: 'rgba(124, 58, 237, 0.22)',
  aiAccentBg: '#f5f3ff',
  aiAccentText: '#5b21b6',
  sevCritical: '#dc2626',
  sevCriticalBg: '#fef2f2',
  sevCriticalBorder: '#fecaca',
  sevCriticalText: '#991b1b',
  sevMajor: '#ea580c',
  sevMajorBg: '#fff7ed',
  sevMajorBorder: '#fed7aa',
  sevMajorText: '#9a3412',
  sevMinor: '#ca8a04',
  sevMinorBg: '#fefce8',
  sevMinorBorder: '#fef08a',
  sevMinorText: '#854d0e',
  sevInfo: '#2563eb',
  sevInfoBg: '#eff6ff',
  sevInfoBorder: '#bfdbfe',
  sevInfoText: '#1e40af',
  accentWash: 'rgba(37, 99, 235, 0.05)',
  accentSoft: 'rgba(37, 99, 235, 0.1)',
  accentOutline: 'rgba(37, 99, 235, 0.2)',
  accentPulse: 'rgba(37, 99, 235, 0.55)',
  accentPulseOut: 'rgba(37, 99, 235, 0)',
  successWash: 'rgba(22, 163, 74, 0.08)',
  warningWash: 'rgba(245, 158, 11, 0.1)',
  warningOutline: 'rgba(245, 158, 11, 0.35)',
  dangerWash: 'rgba(220, 38, 38, 0.08)',
  dangerOutline: 'rgba(220, 38, 38, 0.3)',
  hairline: 'rgba(13, 13, 13, 0.06)',
  hairlineStrong: 'rgba(13, 13, 13, 0.14)',
  washInverse: 'rgba(255, 255, 255, 0.9)',
  commentHighlight: 'rgba(255, 214, 10, 0.35)',
  commentHighlightActive: 'rgba(255, 193, 7, 0.7)',
  commentUnderline: 'rgba(214, 158, 0, 0.7)',
  annoGlossary: '#facc15',
  annoGlossaryTint: 'rgba(250, 204, 21, 0.2)',
  annoGlossaryChip: 'rgba(250, 204, 21, 0.25)',
  annoGlossaryStrong: 'rgba(250, 204, 21, 0.35)',
  annoGlossarySwatch: 'rgba(250, 204, 21, 0.55)',
  annoProperNoun: '#60a5fa',
  annoProperNounTint: 'rgba(96, 165, 250, 0.2)',
  annoProperNounChip: 'rgba(96, 165, 250, 0.25)',
  annoProperNounStrong: 'rgba(96, 165, 250, 0.35)',
  annoProperNounSwatch: 'rgba(96, 165, 250, 0.55)',
  annoPreservation: '#34d399',
  annoPreservationTint: 'rgba(52, 211, 153, 0.2)',
  annoPreservationChip: 'rgba(52, 211, 153, 0.25)',
  annoPreservationStrong: 'rgba(52, 211, 153, 0.35)',
  annoPreservationSwatch: 'rgba(52, 211, 153, 0.55)',
  annoCriticFix: '#fb923c',
  annoCriticFixTint: 'rgba(251, 146, 60, 0.2)',
  annoCriticFixChip: 'rgba(251, 146, 60, 0.25)',
  annoCriticFixStrong: 'rgba(251, 146, 60, 0.35)',
  annoCriticFixSwatch: 'rgba(251, 146, 60, 0.55)',
  annoConsistency: '#a78bfa',
  annoConsistencyTint: 'rgba(167, 139, 250, 0.2)',
  annoConsistencyChip: 'rgba(167, 139, 250, 0.25)',
  annoConsistencyStrong: 'rgba(167, 139, 250, 0.35)',
  annoConsistencySwatch: 'rgba(167, 139, 250, 0.55)',
  annoSeverityCritical: '#f87171',
  annoSeverityCriticalTint: 'rgba(239, 68, 68, 0.2)',
  annoSeverityMinorTint: 'rgba(163, 163, 163, 0.2)',
  chart1: '#2563eb',
  chart2: '#7c3aed',
  chart3: '#16a34a',
  chart4: '#f59e0b',
  chart5: '#ec4899',
  chart6: '#0891b2',
  vendorDeepl: '#0f2b46',
  vendorDeeplActive: '#1e4d7c',
  vendorDeeplShade: '#142c46',
  vendorDeeplTint: 'rgba(15, 43, 70, 0.06)',
  vendorDeeplBorder: 'rgba(15, 43, 70, 0.1)',
  vendorTelegram: '#0088cc',
  vendorTelegramHover: '#0077b5',
  focusRingColor: 'rgba(37, 99, 235, 0.32)',
  primaryColor: '#2563eb',
  primaryHover: '#1d4ed8',
  primaryLight: '#eff6ff',
  textPrimary: '#1a1a1a',
  textSecondary: '#5c5c5c',
  backgroundColor: '#f7f7f7',
  surfaceColor: '#ffffff',
  borderColor: '#e2e2e2',
  successColor: '#16a34a',
  warningColor: '#f59e0b',
  errorColor: '#dc2626',
  fail: '#dc2626',
  failBg: '#fef2f2',
};

/* Categorical series order for charts. Brand blue leads; the rest are
 * spaced far enough apart in hue to stay separable at 2px stroke. */
export const CHART_SERIES = [
  COLORS.chart1,
  COLORS.chart2,
  COLORS.chart3,
  COLORS.chart4,
  COLORS.chart5,
  COLORS.chart6,
];
